const isDomainRebrand = window.location.hostname === process.env.APP_DOMAIN_REBRAND;

export default {
  urls: {
    API_ENDPOINT: isDomainRebrand
      ? process.env.API_ENDPOINT_REBRAND : process.env.API_ENDPOINT,
    KLICKART_URL: isDomainRebrand
      ? process.env.KLICKART_URL_REBRAND : process.env.KLICKART_URL,
    KLICKART_AUTH_URI: isDomainRebrand
      ? process.env.KLICKART_AUTH_URI_REBRAND : process.env.KLICKART_AUTH_URI,
    EDITOR_API_ENDPOINT: isDomainRebrand
      ? process.env.EDITOR_API_ENDPOINT_REBRAND : process.env.EDITOR_API_ENDPOINT,
    EDITOR_URL: isDomainRebrand
      ? process.env.EDITOR_URL_REBRAND : process.env.EDITOR_URL,
    PAGE_MANAGER_URL: isDomainRebrand
      ? process.env.PAGE_MANAGER_URL_REBRAND : process.env.PAGE_MANAGER_URL,
  },
};



// WEBPACK FOOTER //
// ./src/config/rebrand/index.js